const modulePages = [
	{
		id: 'm4-intro',
		isFacilitatorOnly: true,
		title: 'Intro til modulet',
		facilitatorInstructions: `Følg guiden. 
			<br /><br />Fortæl eleverne, hvad der skal ske på modul 4.`,
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
			id: 'the-bad-circle',
			type: 'image', 
			text: 'Den svære cirkel'
		},
		{
			id: 'toolbox',
			type: 'image',
			text: 'Værktøjskassen'
		},
	]	
	},
	{
		id: 'm4-problem-solving',
		isFacilitatorOnly: true,
		title: 'Feedback',
		facilitatorInstructions: `Følg guiden trin for trin.
			<br/><br/>Eleverne fortæller, hvordan det er gået med basalplanen, og der gennemføres en fælles problemløsning.
			<br/><br/>Husk, at du selv er rollemodel.`,
		facilitatorText: `<strong>Hvad gik din basalplan ud på?</strong><br/><br/>
			<strong>Hvordan er det gået med din basalplan?</strong><br/><br/>
			<strong>Mulighed for problemløsning</strong>`,
		icons: ['plan-of-action', 'problem-solving'],
		slides: [
			{
				id: 'plan-of-action',
				type: 'image',
				text: 'Basalplansskema'
			},
			{
				id: 'problem-solving',
				type: 'image',
				text: 'Problemløsningsskema'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			},
		]	
	},
	{
		id: 'm4-emotion-memory',
		isFacilitatorOnly: true,
		title: 'Følelsesmemory',
		facilitatorInstructions: `Følg guiden.
			<br /><br />Lav øvelsen "Følelsesmemory".`,
		facilitatorText: `Følelsesmemory.`,
		facilitatorDownloads: [{
			title: 'Følelsesmemory',
			file: '0622_Basal_undervisningsvejledning_A4_memory.pdf'
		}],
		groupInstructions: null,
		groupText: null,
		icons: ['thinking-brain'],
		slides: [
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			},
		]
	},
	{
		id: 'm4-communication',
		isFacilitatorOnly: false,
		title: 'Kommunikation',
		facilitatorInstructions: `Følg guiden.
			<br /><br />Demonstrer opgaven.
			<br /><br />Eleverne arbejder i www.basalsammen.dk.`,
		facilitatorText: `Gå sammen i grupper på 4.
			<br /><br />Gå til <strong>www.basalsammen.dk.</strong>
			<br /><br />Skriv kode i elevlogin.
			<br /><br /><span><%GAMECODE%></span>`,
		groupInstructions: `Skim eksemplerne, og vælg et eksempel på en dialog, som I læser højt for hinanden. Én i gruppen er person 1, en anden er person 2. De andre observerer, hvad de hører i samtalen og giver feedback ud fra følgende spørgsmål:
			<br /><br />Hvad fungerer godt? Hvorfor?
			<br /><br />Hvad fungerer mindre godt? Hvorfor?
			<br /><br />Hvornår bruges der jeg-sprog og du-sprog i dialogerne?`,
		groupText: `Eksempler på dialoger:`,
		icons: ['communication', 'online-teaching'],
		slides: [
			{
				id: 'dialogue-example-1',
				type: 'dialogue-examples',
				btnText: 'Eksempel 1',
				text: `Eksempel 1 - delt`,
				examples: [
					{
						id: 1,
						title: 'du-sprog',
						dialogue: [
							{person: 'Basally', text: `Du er så respektløs! Hvorfor delte du det billede af mig?`},
							{person: 'Basil', text: `Det var bare for sjov – slap dog af.`},
							{person: 'Basally', text: `Du tænker aldrig over, hvordan andre har det.`},
							{person: 'Basil', text: `Det var ikke ondt ment.`},
							{person: 'Basally', text: `Jeg taler aldrig til dig mere, hvis du gør det igen!`}
						]
					},
					{
						id: 2,
						title: 'jeg-sprog',
						dialogue: [
							{person: 'Basally', text: `Jeg blev ret ked af det, da jeg så, at det billede var blevet delt.`},
							{person: 'Basil', text: `Slap nu af – det var bare for sjov!`},
							{person: 'Basally', text: `Det kan godt være, men jeg føler bare, det var virkelig grænseoverskridende. Jeg gad ikke, at andre skulle se det.`},
							{person: 'Basil', text: `Okay, det kan jeg godt se. Jeg fjerner det – det var ikke meningen at gøre dig ked af det.`},
							{person: 'Basally', text: `Godt! Tak.`}
						]
					}
				]
			},
			{
				id: 'dialogue-example-2',
				type: 'dialogue-examples',
				btnText: `Eksempel 2`,
				text: `Eksempel 2 - rodehoved`,
				examples: [
					{
						id: 1,
						title: 'du-sprog',
						dialogue: [
							{person: 'Basil', text: `Ej, hallo, du fylder sygt meget på dit bord! `},
							{person: 'Basally', text: `Ro på, har du lige set dit eget bord?`},
							{person: 'Basil', text: `What? Det er sgu da ikke værre end dit rod!`},
							{person: 'Basally', text: `Du er den sidste, jeg gider at sidde ved siden af – jeg bliver vanvittig!`}
						]
					},
					{
						id: 2,
						title: 'jeg-sprog',
						dialogue: [
							{person: 'Basil', text: `Ej, seriøst, jeg kan ikke koncentrere mig, når der ligger alt det crap på bordet.`},
							{person: 'Basally', text: `Du roder da lige så meget selv, mand.`},
							{person: 'Basil', text: `Ja, fair nok, men lige nu går det mig bare på. Kan vi ikke lige få ryddet lidt op?`},
							{person: 'Basally', text: `Okay, chill. Vi tager det sammen.`},
							{person: 'Basil', text: `Fedt, tak.`}
						]
					}
				]
			},
			{
				id: 'dialogue-example-3',
				type: 'dialogue-examples',
				btnText: `Eksempel 3`,
				text: `Eksempel 3 - bare for sjov`,
				examples: [
					{
						id: 1,
						title: 'du-sprog',
						dialogue: [
							{person: 'Basally', text: `Wow, fed frisure. Har du selv klippet det?`},
							{person: 'Basil', text: `Tusind tak for bare at svine mig til.`},
							{person: 'Basally', text: `Du er altid så nærtagende. Det var bare for sjov.`},
							{person: 'Basil', text: `Sjov? Det er overhovedet ikke sjovt. Du skal altid kommentere på alt.`},
							{person: 'Basally', text: `Seriøst? Jeg siger det jo bare, som det er.`},
							{person: 'Basil', text: `Du er så mega irriterende! Skrid.`}
						]
					},
					{
						id: 2,
						title: 'jeg-sprog',
						dialogue: [
							{person: 'Basally', text: `Wow, fed frisure. Har du selv klippet det?`},
							{person: 'Basil', text: `Jeg forstår ikke ... mener du det, eller laver du sjov?`},
							{person: 'Basally', text: `Nej, nej, det ser fedt ud til dig.`},
							{person: 'Basil', text: `Ok. Nogle gange har jeg bare virkelig svært ved at finde ud af, om du laver sjov med mig eller ej.`},
							{person: 'Basally', text: `Ok, fair. Det klæder dig helt seriøst.`}
						]
					}
				]
			},
			{
				id: 'dialogue-example-4',
				type: 'dialogue-examples',
				btnText: `Eksempel 4`,
				text: `Eksempel 4 - flyt dig`,
				examples: [
					{
						id: 1,
						title: 'du-sprog',
						dialogue: [
							{person: 'Basally', text: `Flyt dig! Du har taget min plads.`},
							{person: 'Basil', text: `Slap dog af. Jeg sad her først.`},
							{person: 'Basally', text: `Du tager altid min plads. Kan du ikke fatte, at det ikke er din?`},
							{person: 'Basil', text: `Hallo, jeg sidder her bare lige i frikvarteret – skrid med dig!`}
						]
					},
					{
						id: 2,
						title: 'jeg-sprog',
						dialogue: [
							{person: 'Basally', text: `Hey, jeg vil gerne have min plads tilbage. Det ringer snart ind.`},
							{person: 'Basil', text: `Slap nu af, jeg satte mig bare – chill lidt, det er jo bare en stol.`},
							{person: 'Basally', text: `Det er cool, jeg siger det ikke for at skabe drama. Det ringer bare snart ind.`},
							{person: 'Basil', text: `Ok, jeg rykker mig.`},
							{person: 'Basally', text: `Tak, fedt!`}
						]
					}
				]
			},
			{
				id: 'dialogue-example-5',
				type: 'dialogue-examples',
				btnText: `Eksempel 5`,
				text: `Eksempel 5 - gruppearbejde`,
				examples: [
					{
						id: 1,
						title: 'du-sprog',
						dialogue: [
							{person: 'Basally', text: `Du laver jo aldrig en skid! Vi andre ender altid med at lave alt!`},
							{person: 'Basil', text: `Slap af, mand – jeg har lavet lige så meget som jer.`},
							{person: 'Basally', text: `Jamen, du sidder jo bare med din telefon hele tiden!`},
							{person: 'Basil', text: `Og du ved sgu da ikke, om jeg bruger den til at tjekke fakta til opgaven.`},
							{person: 'Basally', text: `Seriøst! Så fortæl os dog, hvad du har fundet ud af?`}
						]
					},
					{
						id: 2,
						title: 'jeg-sprog',
						dialogue: [
							{person: 'Basally', text: `Du laver jo aldrig en skid! Vi andre ender altid med at lave alt!`},
							{person: 'Basil', text: `Jeg synes faktisk, jeg har lavet noget – bare ikke det samme som jer.`},
							{person: 'Basally', text: `Jamen, du sidder jo bare med din telefon hele tiden!`},
							{person: 'Basil', text: `Jeg er ved at tjekke nogle fakta til opgaven. Vil I se, hvad jeg har fundet?`},
							{person: 'Basally', text: `Okay, vi troede, du gamede eller sådan noget. Hvad har du tjekket?`}
						]
					}
				]
			},
			{
				id: 'communication',
				type: 'image',
				text: 'Kommunikation'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			},
		]
	},

	{
		id: 'm4-basal-plan',
		isFacilitatorOnly: true,
		title: 'Basalplan',
		menuTitle: 'Basalplan',
		facilitatorInstructions: `Følg guiden trin for trin. Eleverne udarbejder hver en basalplan. Husk, at du selv er rollemodel og også selv skal lave en basalplan.`,
		facilitatorText: `<strong>Opgave:</strong> <br/>
		Gå sammen to og to, og hjælp hinanden med at lave en basalplan.`,
		groupText: null,
		icons: ['plan-of-action'],
		slides: [
			{
				id: 'plan-of-action',
				type: 'image',
				text: 'Basalplansskema'
			},
			{
				id: 'problem-solving',
				type: 'image',
				text: 'Problemløsningsskema'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskassen'
			},
			{
				id: 'idea-round',
				type: 'image',
				text: 'Idérunde'
			},
		],
		minigames: []
	},
	{
		id: 'm4-finish',
		isFacilitatorOnly: true,
		title: 'Afrunding',
		menuTitle: 'Afrunding',
		facilitatorInstructions: `Følg guiden.`,
		facilitatorText: `<strong>Hvad var sjovt eller skørt?</strong> <br/><br/>
		<strong>Hvad har givet dig noget at tænke over?</strong><br/><br/>
		<strong>Hvordan gør du dine klassekammerater glade?</strong>`,
		groupText: null,
		icons: ['toolbox'],
		slides: [
			{
				id: 'toolbox',
				type: 'image',
				text: 'Værktøjskasse'
			},
			{
				id: 'the-bad-circle',
				type: 'image', 
				text: 'Den svære cirkel'
			},
		],
	},
];


export {
	modulePages
};